<template>
  <div class="declarations-modal-container">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <h3 class="title has-text-white has-text-centered">
            {{ isRegionalStep ? 'Preferência Regional' : 'Declarações' }}
          </h3>
          <div class="box custom-box">
            <div v-if="!isRegionalStep" class="modal-body">
              <div class="declarations-section">
                <h3 class="section-title">Declarações Gerais</h3>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.direitosTrabalhistas">
                      {{ declarationsList.direitosTrabalhistas.text }}
                    </b-checkbox>
                    <b-tooltip
                      position="is-bottom"
                      :label="declarationsList.direitosTrabalhistas.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.direitosTrabalhistas.fundamento }}
                  </div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.inexistenciaFatoImpeditivo">
                      {{ declarationsList.inexistenciaFatoImpeditivo.text }}
                    </b-checkbox>
                    <b-tooltip
                      position="is-bottom"
                      :label="declarationsList.inexistenciaFatoImpeditivo.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.inexistenciaFatoImpeditivo.fundamento }}
                  </div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.responsabilidadeVeracidade">
                      {{ declarationsList.responsabilidadeVeracidade.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.responsabilidadeVeracidade.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.responsabilidadeVeracidade.fundamento }}
                  </div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.conhecimentoEdital">
                      {{ declarationsList.conhecimentoEdital.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.conhecimentoEdital.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">{{ declarationsList.conhecimentoEdital.fundamento }}</div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.cumprimentoRequisitos">
                      {{ declarationsList.cumprimentoRequisitos.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.cumprimentoRequisitos.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.cumprimentoRequisitos.fundamento }}
                  </div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.responsabilidadeOperacoes">
                      {{ declarationsList.responsabilidadeOperacoes.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.responsabilidadeOperacoes.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.responsabilidadeOperacoes.fundamento }}
                  </div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.naoUtilizaTrabalhoInfantil">
                      {{ declarationsList.naoUtilizaTrabalhoInfantil.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.naoUtilizaTrabalhoInfantil.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.naoUtilizaTrabalhoInfantil.fundamento }}
                  </div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.naoEstaEmHipotesesImpeditivas">
                      {{ declarationsList.naoEstaEmHipotesesImpeditivas.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.naoEstaEmHipotesesImpeditivas.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.naoEstaEmHipotesesImpeditivas.fundamento }}
                  </div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.naoHaConflitoInteresses">
                      {{ declarationsList.naoHaConflitoInteresses.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.naoHaConflitoInteresses.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.naoHaConflitoInteresses.fundamento }}
                  </div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.cumpreLeiAnticorrupcao">
                      {{ declarationsList.cumpreLeiAnticorrupcao.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.cumpreLeiAnticorrupcao.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.cumpreLeiAnticorrupcao.fundamento }}
                  </div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.cumpreLGPD">
                      {{ declarationsList.cumpreLGPD.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.cumpreLGPD.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">{{ declarationsList.cumpreLGPD.fundamento }}</div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.naoHaNepotismo">
                      {{ declarationsList.naoHaNepotismo.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.naoHaNepotismo.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">{{ declarationsList.naoHaNepotismo.fundamento }}</div>
                </div>

                <div class="field declaration-item">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.cumprimentoReservaCargosPCDReabilitados">
                      {{ declarationsList.cumprimentoReservaCargosPCDReabilitados.text }}
                    </b-checkbox>
                    <b-tooltip
                      position="is-left"
                      :label="declarationsList.cumprimentoReservaCargosPCDReabilitados.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.cumprimentoReservaCargosPCDReabilitados.fundamento }}
                  </div>
                </div>

                <h3 v-if="showME_EPP_MEI_Declarations" class="section-title">
                  Declarações Específicas
                </h3>

                <div class="field declaration-item" v-if="showME_EPP_MEI_Declarations">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.souME_EPP_MEI">
                      {{ declarationsList.souME_EPP_MEI.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.souME_EPP_MEI.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">{{ declarationsList.souME_EPP_MEI.fundamento }}</div>
                </div>

                <div class="field declaration-item" v-if="showME_EPP_MEI_Declarations">
                  <div class="checkbox-with-tooltip">
                    <b-checkbox v-model="declarations.naoEstaEmHipotesesImpeditivasTratamento">
                      {{ declarationsList.naoEstaEmHipotesesImpeditivasTratamento.text }}
                    </b-checkbox>
                    <b-tooltip
                      :label="declarationsList.naoEstaEmHipotesesImpeditivasTratamento.tooltip"
                      size="is-medium"
                      multilined
                    >
                      <b-icon icon="help-circle" size="is-small" class="help-icon" type="is-info" />
                    </b-tooltip>
                  </div>
                  <div class="fundamento">
                    {{ declarationsList.naoEstaEmHipotesesImpeditivasTratamento.fundamento }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!isRegionalStep" class="declarations-actions">
              <div class="field">
                <b-checkbox v-model="selectAll" @input="toggleAllDeclarations">
                  Marcar todas
                </b-checkbox>
              </div>
              <div class="section-title mt-4">
                *Ao selecionar a opção concordo, declaro que cumpro e estou ciente de todas as
                declarações.
              </div>
            </div>
            <div v-else class="regional-preference-content">
              <h3 class="section-title">Declaração de Preferência Regional</h3>
              <div class="field declaration-item">
                <div class="checkbox-with-tooltip">
                  <div class="regional-question">
                    Você deseja utilizar o direito de preferência regional neste(a)
                    {{ auctionTypeLabel }}?
                  </div>
                  <b-tooltip
                    position="is-left"
                    label="Utilizando este direito, você declara que a empresa atende aos requisitos para direito de preferência local/regional conforme parágrafo 3º do artigo 48 da Lei Complementar 123/2006. LC 123/2006, art. 48, § 3º."
                    size="is-medium"
                    multilined
                  >
                    <span class="help-question-mark">?</span>
                  </b-tooltip>
                </div>
                <div class="fundamento">LC 123/2006, art. 48, § 3º.</div>
              </div>
            </div>

            <div class="footer-container">
              <div class="buttons-container has-text-right">
                <b-button
                  class="is-danger ml-1"
                  :size="mobile ? 'is-small is-outlined' : 'is-normal is-outlined'"
                  @click.stop.prevent="secondaryAction"
                >
                  {{ secondaryButtonLabel }}
                </b-button>
                <b-button
                  ref="confirm"
                  class="button is-primary ml-1"
                  type="is-primary"
                  :size="mobile ? 'is-small' : 'is-normal'"
                  :disabled="(!canConfirm && !isRegionalStep) || isConfirming"
                  @click.stop.prevent="primaryAction"
                >
                  {{ primaryButtonLabel }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getOfertaCompraEnum } from '../../../../utils/enumerados';

export default {
  name: 'DeclarationsModal',
  props: {
    showPreference: {
      type: Boolean,
      default: false,
    },
    companySize: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectAll: false,
      isConfirming: false,
      modalStep: 'general',
      declarations: {
        direitosTrabalhistas: false,
        inexistenciaFatoImpeditivo: false,
        responsabilidadeVeracidade: false,
        conhecimentoEdital: false,
        cumprimentoRequisitos: false,
        responsabilidadeOperacoes: false,
        naoUtilizaTrabalhoInfantil: false,
        naoEstaEmHipotesesImpeditivas: false,
        naoHaConflitoInteresses: false,
        cumpreLeiAnticorrupcao: false,
        cumpreLGPD: false,
        naoHaNepotismo: false,
        cumprimentoReservaCargosPCDReabilitados: false,
        souME_EPP_MEI: false,
        naoEstaEmHipotesesImpeditivasTratamento: false,
      },
      declarationsList: {
        direitosTrabalhistas: {
          text: 'Direitos trabalhistas incluídos na proposta',
          tooltip:
            'Confirmo que a proposta contempla todos os custos com direitos trabalhistas previstos na CF/88, legislação trabalhista, normas coletivas e demais obrigações legais.',
          fundamento: 'CF/88, art. 7º; Lei 14.133/21, arts. 5º e 11.',
        },
        inexistenciaFatoImpeditivo: {
          text: 'Inexistência de fato impeditivo',
          tooltip:
            'Declaro que não há fato que impeça a empresa de licitar ou contratar com a Administração, nem sanção vigente que restrinja a participação.',
          fundamento: 'Lei 14.133/21, arts. 14 e 155.',
        },
        responsabilidadeVeracidade: {
          text: 'Responsabilidade pela veracidade das declarações',
          tooltip:
            'Tenho ciência de que prestar declaração falsa pode caracterizar crime (art. 299 do Código Penal) e gerar sanções administrativas na forma da Lei 14.133/21.',
          fundamento: 'Código Penal, art. 299; Lei 14.133/21, arts. 156 e 158.',
        },
        conhecimentoEdital: {
          text: 'Conhecimento e aceitação do edital',
          tooltip: 'Confirmo que li, compreendi e aceito integralmente o edital e seus anexos.',
          fundamento: 'Lei 14.133/21, arts. 5º e 17.',
        },
        cumprimentoRequisitos: {
          text: 'Cumprimento dos requisitos de habilitação',
          tooltip:
            'Declaro que a empresa atende a todos os requisitos de habilitação exigidos no edital e que os documentos apresentados são verdadeiros.',
          fundamento: 'Lei 14.133/21, arts. 62 a 70.',
        },
        responsabilidadeOperacoes: {
          text: 'Responsabilidade pelas operações no sistema',
          tooltip:
            'Sou responsável por todas as ações realizadas com meu usuário (login, senha, certificado, PIN), inclusive envio de propostas, lances e documentos.',
          fundamento: 'Lei 14.133/21, arts. 17 e 12; normas da plataforma.',
        },
        naoUtilizaTrabalhoInfantil: {
          text: 'Não utilizo trabalho infantil em condições proibidas',
          tooltip:
            'Declaro que não emprego menores em condições vedadas (trabalho noturno, perigoso, insalubre ou antes da idade permitida), salvo como aprendiz a partir de 14 anos.',
          fundamento: 'CF/88, art. 7º, XXXIII; Lei 14.133/21, art. 68, VI.',
        },
        naoEstaEmHipotesesImpeditivas: {
          text: 'Não estou em hipóteses de impedimento ou vedação legal',
          tooltip:
            'A empresa não se enquadra nas vedações do art. 9º da Lei 14.133/21 (situações de impedimento à participação).',
          fundamento: 'Lei 14.133/21, art. 9º.',
        },
        naoHaConflitoInteresses: {
          text: 'Não há conflito de interesses com agentes do órgão',
          tooltip:
            'Não há participação de agentes públicos deste órgão, nas hipóteses vedadas, como sócios ou administradores da empresa, nas situações do art. 14, IV, da Lei 14.133/21.',
          fundamento: 'Lei 14.133/21, art. 14, IV.',
        },
        cumpreLeiAnticorrupcao: {
          text: 'Cumpro a Lei Anticorrupção e não combinarei preços',
          tooltip:
            'Declaro que a empresa não pratica atos lesivos à Administração (Lei 12.846/2013) e que não fará ajuste ou combinação com concorrentes para fraudar a competição.',
          fundamento: 'Lei 12.846/2013; Lei 14.133/21, art. 5º.',
        },
        cumpreLGPD: {
          text: 'Cumpro a LGPD no tratamento de dados',
          tooltip:
            'A empresa observa a Lei Geral de Proteção de Dados (LGPD) no tratamento de dados pessoais relacionados a esta licitação e eventual contrato.',
          fundamento: 'Lei 13.709/2018.',
        },
        naoHaNepotismo: {
          text: 'Não há situação de nepotismo vedado',
          tooltip:
            'Declaro que não há parentesco vedado com agentes públicos deste órgão, nas hipóteses de nepotismo previstas em decreto ou normas locais.',
          fundamento: 'Dec. 7.203/2010 (União) e normas locais equivalentes.',
        },
        cumprimentoReservaCargosPCDReabilitados: {
          text: 'Cumprimento das exigências de reserva de cargos para pessoa com deficiência e reabilitados',
          tooltip:
            'Declaro que o licitante cumpre as exigências de reserva de cargos para pessoa com deficiência e para reabilitado da Previdência Social, previstas em lei e em outras normas específicas.',
          fundamento: 'Lei 8.213/1991, art. 93; demais normas aplicáveis.',
        },
        souME_EPP_MEI: {
          text: 'Sou ME, EPP ou MEI conforme LC 123/2006',
          tooltip:
            'Declaro que a empresa está formalmente enquadrada como ME, EPP ou MEI e pode usufruir dos benefícios previstos na LC 123/2006.',
          fundamento: 'LC 123/2006, arts. 3º e 42; Lei 14.133/21, art. 4º.',
        },
        naoEstaEmHipotesesImpeditivasTratamento: {
          text: 'Não estou em hipóteses impeditivas ao tratamento favorecido',
          tooltip:
            'Declaro que a empresa não está em nenhuma das situações que impedem o tratamento favorecido (ex.: participação em outra empresa que ultrapasse limite de receita, grupo econômico, etc.).',
          fundamento: 'LC 123/2006, art. 3º, §§ 4º e seguintes.',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      auction: 'obterOfertaCompra',
    }),
    ...mapGetters('app', { mobile: 'mobile' }),
    showME_EPP_MEI_Declarations() {
      const validCompanySizes = ['MEI', 'ME', 'EPP', 'COOPERATIVA_PREFERENCIA'];
      return this.companySize && validCompanySizes.includes(this.companySize);
    },
    isRegionalStep() {
      return this.modalStep === 'regional';
    },
    shouldShowRegionalPreferenceStep() {
      return (
        this.showME_EPP_MEI_Declarations &&
        this.showPreference &&
        this.auction &&
        this.auction.preferencia_regional === true
      );
    },
    auctionTypeLabel() {
      return getOfertaCompraEnum(this.auction.tipo).titleSingular;
    },
    primaryButtonLabel() {
      if (this.isRegionalStep) return 'Sim';
      return !this.isRegionalStep && this.shouldShowRegionalPreferenceStep ? 'Próximo' : 'Concordo';
    },
    secondaryButtonLabel() {
      return this.isRegionalStep ? 'Não' : 'Cancelar';
    },
    canConfirm() {
      const generalValid =
        this.declarations.direitosTrabalhistas &&
        this.declarations.inexistenciaFatoImpeditivo &&
        this.declarations.responsabilidadeVeracidade &&
        this.declarations.conhecimentoEdital &&
        this.declarations.cumprimentoRequisitos &&
        this.declarations.responsabilidadeOperacoes &&
        this.declarations.naoUtilizaTrabalhoInfantil &&
        this.declarations.naoEstaEmHipotesesImpeditivas &&
        this.declarations.naoHaConflitoInteresses &&
        this.declarations.cumpreLeiAnticorrupcao &&
        this.declarations.cumpreLGPD &&
        this.declarations.naoHaNepotismo &&
        this.declarations.cumprimentoReservaCargosPCDReabilitados;

      const meEppMeiValid = this.showME_EPP_MEI_Declarations
        ? this.declarations.souME_EPP_MEI &&
          this.declarations.naoEstaEmHipotesesImpeditivasTratamento
        : true;

      return generalValid && meEppMeiValid;
    },
  },
  methods: {
    toggleAllDeclarations() {
      const value = this.selectAll;
      // Declarações 1-13: sempre presentes
      this.declarations.direitosTrabalhistas = value;
      this.declarations.inexistenciaFatoImpeditivo = value;
      this.declarations.responsabilidadeVeracidade = value;
      this.declarations.conhecimentoEdital = value;
      this.declarations.cumprimentoRequisitos = value;
      this.declarations.responsabilidadeOperacoes = value;
      this.declarations.naoUtilizaTrabalhoInfantil = value;
      this.declarations.naoEstaEmHipotesesImpeditivas = value;
      this.declarations.naoHaConflitoInteresses = value;
      this.declarations.cumpreLeiAnticorrupcao = value;
      this.declarations.cumpreLGPD = value;
      this.declarations.naoHaNepotismo = value;
      this.declarations.cumprimentoReservaCargosPCDReabilitados = value;
      // Declarações 14-15: apenas para ME/EPP/MEI/COOPERATIVA_PREFERENCIA
      if (this.showME_EPP_MEI_Declarations) {
        this.declarations.souME_EPP_MEI = value;
        this.declarations.naoEstaEmHipotesesImpeditivasTratamento = value;
      }
    },
    cancel() {
      this.$emit('cancel');
    },
    emitConfirm(regionalPreferenceValue = null) {
      if (this.isConfirming) return;
      this.isConfirming = true;
      this.$emit('confirm', {
        requirements: true,
        regionalPreference: regionalPreferenceValue,
      });
    },
    secondaryAction() {
      if (this.isRegionalStep) {
        this.emitConfirm(false);
        return;
      }
      this.cancel();
    },
    primaryAction() {
      if (this.isRegionalStep) {
        this.emitConfirm(true);
        return;
      }
      this.confirm();
    },
    confirm() {
      if (!this.canConfirm || this.isConfirming) return;

      if (!this.isRegionalStep && this.shouldShowRegionalPreferenceStep) {
        this.modalStep = 'regional';
        return;
      }

      this.emitConfirm(null);
    },
  },
};
</script>

<style lang="scss" scoped>
.declarations-modal {
  padding: 1.5rem;
}

.modal-header {
  margin-bottom: 1.5rem;
}

.modal-body {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 0.5rem;
}

.declarations-section {
  margin-bottom: 1.5rem;
}

.declarations-actions {
  padding-top: 0.5rem;
}

.regional-preference-content {
  padding: 0.5rem 0;
}

.regional-question {
  margin-bottom: 0;
  margin-left: var(--declaration-indent);
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #363636;
}

.field {
  margin-bottom: 0.75rem;
}

.declaration-item {
  margin-bottom: 1rem;
  --declaration-indent: 1.75rem;
}

.fundamento {
  font-size: 0.85rem;
  color: #7a7a7a;
  font-style: italic;
  margin-top: 0.25rem;
  margin-left: var(--declaration-indent);
}

.checkbox-with-tooltip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.declaration-item :deep(.b-checkbox.checkbox) {
  display: inline-flex;
  align-items: flex-start;
}

.declaration-item :deep(.b-checkbox.checkbox .check) {
  margin-top: 0.125rem;
}

.declaration-item :deep(.b-checkbox.checkbox .control-label) {
  margin-left: 0.5rem;
}

.help-icon {
  cursor: help;
  flex-shrink: 0;
}

.help-question-mark {
  width: 1rem;
  height: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #3273dc;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: help;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e5e5;
}

.mt-4 {
  margin-top: 1rem;
}
</style>
